export default __webpack_public_path__ + "static/media/requestOTP.850885f8.png";